export default __webpack_public_path__ + "static/media/logo.1177b499.png";